var React = require('react');

function ArrowLeftInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7 14L8.41 12.59L3.83 8L20 8L20 6L3.83 6L8.42 1.41L7 1.1365e-06L-6.11959e-07 7L7 14Z","fill":"white"}));
}

ArrowLeftInline.defaultProps = {"width":"20","height":"14","viewBox":"0 0 20 14","fill":"none"};

module.exports = ArrowLeftInline;

ArrowLeftInline.default = ArrowLeftInline;
